export default __webpack_public_path__ + "static/media/team-layer-0.6a17d779.png";